import { useProductMeta } from '@websrc/Basket/useProductMeta'
import { CSProductDetails } from '@websrc/Typings/ContentStack'
import React from 'react'

import { Asset } from '../Asset/Asset'
import { table } from './ComparisonTable.css'

export function ComparisonTableProductImage({
  product,
  isSticky,
}: {
  product: CSProductDetails
  isSticky: boolean
}) {
  const productMeta = useProductMeta(product.product_number)

  return (
    <div className={isSticky ? '' : table.thead.notSticky.imageContainer}>
      <Asset
        className={isSticky ? table.thead.sticky.image : table.thead.notSticky.image}
        lazyLoading={true}
        objectFit={'contain'}
        sizes={'(min-width: 768px) 200px, 100px'}
        srcSetWidths={[200, 400]}
        thumbnail={productMeta.image}
        video={undefined}
        width={'100%'}
      />
    </div>
  )
}
